'use client';

import React, { useState } from 'react';
import { ConSwitchMolecule } from '@gandalf/babylon/molecules/switch';
import { Translations } from '@frodo/models/types';
import { useCustomerInfo, useVct } from '@frodo/lib/hooks';
import cls from './CustomerTypeSwitcher.module.scss';

type CustomerTypeSwitcherProps = {
  trans: Translations;
  size: 'medium' | 'large';
};

export const CustomerTypeSwitcher = ({
  trans,
  size,
}: CustomerTypeSwitcherProps) => {
  const {
    isB2B: defaultB2B,
    oppositeType,
    isAuthenticated,
  } = useCustomerInfo();
  const { buildVct } = useVct();
  const [isB2B, setIsB2B] = useState(defaultB2B);
  const [isChanging, setChanging] = useState(false);

  if (isAuthenticated) {
    return null;
  }

  const handleToggle = () => {
    if (isChanging) {
      return;
    }
    setChanging(true);
    setIsB2B(!isB2B);

    window.location.href = `/switch/type?customerThemeType=${oppositeType}&vct=${buildVct(oppositeType)}`;
  };

  return (
    <ConSwitchMolecule
      id="switch-customer-type"
      variant="texted"
      size={size}
      checked={!isB2B}
      disabled={isChanging}
      className={cls.wrapper}
      onToggle={handleToggle}
      checkedText={trans['product.hint.tax_inclusive']}
      uncheckedText={trans['product.hint.tax_exclusive']}
    />
  );
};
